import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Contact() {
  return (
    
    <div className="page-wrapper">

  <Helmet>
  <title>Contact ILoveConvert — Support & Feedback</title>
  <meta name="description" content="Get help with ILoveConvert file conversion tools. Contact us for support, feedback or questions." />
  <link rel="canonical" href="https://iloveconvert.in/contact" />
  <meta property="og:title" content="Contact ILoveConvert — Support & Feedback" />
  <meta property="og:description" content="Get help with ILoveConvert file conversion tools." />
  <meta property="og:url" content="https://iloveconvert.in/contact" />
  <meta property="og:type" content="website" />
  <meta name="twitter:card" content="summary" />
  <meta name="twitter:title" content="Contact ILoveConvert — Support & Feedback" />
</Helmet>

      {/* HERO */}
      <div className="page-hero">
        <h1>Contact Us</h1>
        <p>
          We’re here to help you with any questions, issues, or feedback.
        </p>
      </div>

      <div className="page-content">

        {/* CONTACT INFO */}
        <div className="contact-card">
          <h2>📧 Contact Information</h2>
          <p><strong>Email:</strong> <a href="mailto:support@iloveconvert.in">support@iloveconvert.in</a></p>
          <p><strong>Website:</strong> https://iloveconvert.in/</p>
          <p>
            Email is the fastest way to reach us. We reply within 24–48 hours —
            complex issues may take a little longer, but every message gets a
            reply.
          </p>
        </div>

        {/* SUPPORT */}
        <div className="contact-card">
          <h2>💬 Reporting a Problem</h2>
          <p>
            Whether it's a conversion that failed, a broken download, or a page
            that isn't loading right, include these details so we can fix it
            faster:
          </p>
          <ul>
            <li>Tool name (e.g., Merge PDF)</li>
            <li>File type and size</li>
            <li>Description of the issue, including any error message shown</li>
            <li>Device and browser you were using</li>
          </ul>
        </div>

        {/* GRID */}
        <div className="contact-grid">
          <div className="contact-box">
            <h3>⚡ Fast Response</h3>
            <p>We usually reply within 24–48 hours.</p>
          </div>

          <div className="contact-box">
            <h3>🔐 Secure</h3>
            <p>Your files are processed safely and deleted automatically.</p>
          </div>

          <div className="contact-box">
            <h3>💡 Feedback</h3>
            <p>Your ideas help us improve our tools.</p>
          </div>
        </div>

        {/* FEEDBACK & BUSINESS */}
        <div className="contact-card">
          <h2>💡 Feedback & Partnerships</h2>
          <p>
            Have an idea for a new tool or an improvement to an existing one?
            We'd like to hear it — feedback directly shapes what we build next.
            For business, partnership, or advertising inquiries, email us with
            the details and we'll get back to you.
          </p>
        </div>

      </div>
    </div>
  );
}